let globalStackTrace = [];

function compareTwoStrings(first, second) {
	first = first.replace(/\s+/g, "");
	second = second.replace(/\s+/g, "");

	if (first === second) return 1; // identical or empty
	if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

	let firstBigrams = new Map();
	for (let i = 0; i < first.length - 1; i++) {
		const bigram = first.substring(i, i + 2);
		const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;

		firstBigrams.set(bigram, count);
	}

	let intersectionSize = 0;
	for (let i = 0; i < second.length - 1; i++) {
		const bigram = second.substring(i, i + 2);
		const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;

		if (count > 0) {
			firstBigrams.set(bigram, count - 1);
			intersectionSize++;
		}
	}

	return (2.0 * intersectionSize) / (first.length + second.length - 2);
}

const findClosestSectionParent = (current, loop = 0, original) => {
	if (!original) original = current;
	if (!current || loop > 10)
		return original; // Loop max 10 out, return original
	else if (current.nodeName === "SECTION") return current;
	else return findClosestSectionParent(current.parentElement, loop + 1, original);
};

const findAllLinkChildren = (current, loop = 0) => {
	let links = [];
	if (!current || loop > 40) return links; // Loop max 40 children

	if (
		(current.href && current.href !== "" && !current.href.startsWith("javascript:")) ||
		(current.dataset &&
			current.dataset.href &&
			current.dataset.href !== "" &&
			!current.dataset.href.startsWith("javascript:"))
	)
		links.push(current);

	for (let i = 0; i < current.children.length; i++) {
		let linkFound = findAllLinkChildren(current.children[i], loop + 1);
		if (linkFound.length > 0) links = links.concat(linkFound);
	}
	return links;
};

const linkCompare = (pageLink, gizmoLink) => {
	if (pageLink === gizmoLink) return true;
	if (gizmoLink.split("index.page")[0] === pageLink) return true;
	if ((pageLink === "" && gizmoLink === "/") || (pageLink === "/" && gizmoLink === "")) return true; // During publish empty links are switched out with /
	return false;
};

const getSimilaryTextCompare = (pageText, gizmoText) => {
	return compareTwoStrings(pageText.slice(0, 50), gizmoText.slice(0, 50)); // Only compare the 50 first strings
};

const textCompare = (pageText, gizmoText) => {
	//return (encodeURIComponent(pageText) === encodeURIComponent(gizmoText)); // Perfect string match. To strict when things change on page inside a component (like a lamell open up)
	// TODO - 0.6 or 10 first chars might be to loose, adjust if bugs occur
	// 50% Similarity and 10 first characters exact match
	return (
		getSimilaryTextCompare(pageText, gizmoText) >= 0.5 &&
		encodeURIComponent(pageText).slice(0, 10) === encodeURIComponent(gizmoText).slice(0, 10)
	);
};

const findUrlPath = (url) => {
	if (url && url !== "") {
		try {
			if (url.startsWith("/")) return new URL(location.origin + url.split("#")[0].split("?")[0]).pathname;
			else return new URL(url.split("#")[0].split("?")[0]).pathname;
		} catch {
			globalStackTrace.push("Could not parse trigger url: " + url);
		}
	}
	return url;
};

const findClickTrackingElements = (triggerPath, text, url, isComponentTest = false) => {
	let searchForTriggerWithQueryString = (queryString, mustMatchText = true) => {
		let stackTrace = [];
		let queryFound = document.querySelectorAll(queryString);
		let foundElements = []; // Move over to a normal array since NodeList returned from query does not have array functions
		for (let i = 0; i < queryFound.length; i++) {
			foundElements.push(queryFound[i]);
		}
		let foundReturnElements = foundElements.filter((element) => {
			let elHref = findUrlPath(element.href);
			if (elHref === "" && element.dataset && element.dataset.href) elHref = findUrlPath(element.dataset.href);
			let clickedText = element.innerText.trim();
			stackTrace.push({
				page: { text: clickedText, textEncoded: encodeURIComponent(clickedText), href: elHref },
				abtest: { text: text, textEncoded: encodeURIComponent(text), href: url },
				compare: {
					textSimilarity: getSimilaryTextCompare(clickedText, text),
					text: textCompare(clickedText, text),
					url: linkCompare(elHref, url),
				},
			});
			if (isComponentTest)
				// Only compare texts since we are looking for a component (that probably don't have a url on the section element)
				return textCompare(clickedText, text);
			else if (mustMatchText) return textCompare(clickedText, text) && linkCompare(elHref, url);
			return linkCompare(elHref, url); // Blindly only compare link, no text. Not that reliable
		});
		// Fallback if classes not found, just try to find the link
		if (foundElements.length === 0)
			globalStackTrace.push("No elements found on page with query: " + queryString, stackTrace);
		else if (foundReturnElements.length === 0)
			globalStackTrace.push("No matching elements for A/B Test trigger with query: " + queryString, stackTrace);
		else if (!mustMatchText)
			globalStackTrace.push("Unreliable linkmatch for A/B Test trigger: " + queryString, stackTrace);
		else globalStackTrace.push("Match for A/B Test trigger with query: " + queryString, stackTrace);
		globalStackTrace.push("Found total elements: " + foundReturnElements.length, foundReturnElements);
		return foundReturnElements;
	};

	const searchThroughTriggerPath = (mustMatchText = true) => {
		let foundElements = searchForTriggerWithQueryString(triggerPath.join(" "), mustMatchText);
		if (foundElements.length !== 1) {
			// If not 1 uniqe found, search for more
			foundElements = searchForTriggerWithQueryString(triggerPath[triggerPath.length - 1], mustMatchText); // Try to search for only the last element in the hopes of only finding one uniqe element
		}
		let searchedQueryStrings = [];
		if (foundElements.length !== 1) {
			// If not 1 uniqe found, search for more
			let clonedTriggerPath = JSON.parse(JSON.stringify(triggerPath));
			for (let i = clonedTriggerPath.length - 1; i >= 0; i--) {
				// TODO - .split(".")[0] removes all classes at once, should maybe try to remove one class at at time and then search again
				clonedTriggerPath[i] = clonedTriggerPath[i].split(".")[0]; // Remove classes from the last element and up the stack in hopes to find only one element
				let query = clonedTriggerPath.filter((t) => t || t !== "").join(" ");
				if (searchedQueryStrings.indexOf(query) === -1) {
					// Don't search if it has already been searched
					searchedQueryStrings.push(query);
					foundElements = searchForTriggerWithQueryString(query, mustMatchText);
					if (foundElements.length === 1) i = -1; // Break out of the for loop, we have found it! WE HAVE THE GOLDEN TICKET! DING DING DING!
				}
			}
		}
		// We need to make sure we don't have two answers because then we don't know who of those are the correct one chosen by editors, only one is good enough
		return foundElements.length === 1 ? foundElements[0] : null;
	};

	globalStackTrace = [];
	url = findUrlPath(url);
	let foundElement = searchThroughTriggerPath(true);
	if (!foundElement) foundElement = searchThroughTriggerPath(false);
	console.log("A/B Test find trigger stack trace: ", globalStackTrace);
	return foundElement;
};

export default {
	findClickTrackingElements,
	findClosestSectionParent,
	findAllLinkChildren,
};
